import {
    Video,
    electronConfig,
    convertPath,
    isElectron,
    isJoined,
    strTest
} from "../../libs/roomnew";
import { logError, notifyUser } from '../../utils/errorHandler';

// import { startGoogleSignin } from "../../../renderer/libs/Auth/Google/GoogleSignIn";
// import { getData, setUser } from "../../../renderer/libs/user";

export default class LoginModal{
    constructor(){
        this.modal = null;
        this.timeout = 0;

        //Buttons and svg-s
        this.closeModalIcon = `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>`;
        this.googleIcon = `<svg viewBox="0 0 18 18" style="width:22px;height:22px;"><path d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z" fill="#4285F4"/><path d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 0 1-7.18-2.54H1.83v2.07A8 8 0 0 0 8.98 17z" fill="#34A853"/><path d="M4.5 10.52a4.8 4.8 0 0 1 0-3.04V5.41H1.83a8 8 0 0 0 0 7.18l2.67-2.07z" fill="#FBBC05"/><path d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 1.83 5.4L4.5 7.49a4.77 4.77 0 0 1 4.48-3.3z" fill="#EA4335"/></svg>`;
        this.microsoftIcon = `<svg viewBox="0 0 21 21" fill="none" style="width:22px;height:22px;"><rect x="1" y="1" width="9" height="9" fill="#f25022"/><rect x="11" y="1" width="9" height="9" fill="#7fba00"/><rect x="1" y="11" width="9" height="9" fill="#00a4ef"/><rect x="11" y="11" width="9" height="9" fill="#ffb900"/></svg>`;
        this.showPasswordIcon = `<svg class="show-password-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>`;
        this.hidePasswordIcon = `<svg class="hide-password-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"></path></svg>`;
        this.emailIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="#9aa8b0" d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"/></svg>`;
        this.lockIcon = `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="#9aa8b0" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/></svg>`;
        this.events();
    }

    events(){

    }

    renderModal(){
        let lm = this;

        if ($('#signInModalWelcome').length) {
            lm.modal = $('#signInModalWelcome');
            lm.emailInput = lm.modal.find('#session-signin-email');
            lm.passwordInput = lm.modal.find('#session-signin-password');
            lm.emailErrors = lm.modal.find('#session-signin-email-error');
            lm.passwordErrors = lm.modal.find('#session-signin-password-error');
            lm.generalErrorMessage = lm.modal.find('#signInModalWelcomeGeneralError');
            lm.signInButton = lm.modal.find('#session-signin-btn');
            lm.passwordToggleIcon = lm.modal.find('#session-password-toggle-icon');
            lm.modal.modal('show');
            return;
        }

        lm.closeModalButton = $('<button/>',{
            type: 'button',
            class: 'session-auth-modal-close ignore-drag',
            'aria-label': 'Close',
            html: lm.closeModalIcon
        }).on('click', function(){
            if (lm.modal) {
                lm.modal.modal('hide');
            }
            lm.removeModal();
        });

        lm.bannerImage = $('<img/>',{
            src: '/static/media/kinoImage2.48448897.png',
            alt: 'Kino Live'
        });
        lm.banner = $('<div/>',{
            class: 'auth-logo-banner',
            html: lm.bannerImage
        });

        lm.headerTitle = $('<h1/>',{ html: 'Welcome back' });
        lm.headerSubtitle = $('<p/>',{ html: 'Sign in to continue to your workspace' });
        lm.header = $('<div/>',{
            class: 'auth-header',
            html: [lm.headerTitle, lm.headerSubtitle]
        });

        lm.googleContainer = $('<a/>',{
            class: 'auth-social-btn ignore-drag',
            href: `/signin/google?redirect_url=${encodeURIComponent(window.location.href)}`,
            html: `${lm.googleIcon} Google`
        }).on('click', function(e){
            if (isElectron) {
                e.preventDefault();
                startGoogleSignin();
            }
        });

        lm.microsoftContainer = $('<a/>',{
            class: 'auth-social-btn ignore-drag',
            href: `/signin/microsoft?redirect_url=${encodeURIComponent(window.location.href)}`,
            html: `${lm.microsoftIcon} Microsoft`
        });

        lm.socials = $('<div/>', {
            class: 'auth-social-row',
            html: [lm.googleContainer, lm.microsoftContainer]
        });

        lm.divider = $('<div/>',{
            class: 'auth-divider',
            html: 'or'
        });

        lm.generalErrorMessage = $('<div/>',{
            class: 'auth-general-error ignore-drag',
            id: 'signInModalWelcomeGeneralError',
            html: ''
        });

        lm.emailIconEl = $('<span/>',{
            class: 'input-icon',
            html: lm.emailIcon
        });
        lm.emailErrors = $('<div/>',{
            class: 'field-error ignore-drag',
            id: 'session-signin-email-error',
            html: ''
        });
        lm.emailInput = $('<input/>',{
            type: 'email',
            id: 'session-signin-email',
            name: 'email',
            maxlength: 254,
            required: true,
            autocomplete: 'username',
            placeholder: 'Work email',
            class: 'ignore-drag'
        });
        lm.emailGroup = $('<div/>',{
            class: 'auth-input-group',
            html: [lm.emailIconEl, lm.emailInput, lm.emailErrors]
        });

        lm.lockIconEl = $('<span/>',{
            class: 'input-icon',
            html: lm.lockIcon
        });
        lm.passwordToggleIcon = $('<span/>',{
            id: 'session-password-toggle-icon',
            html: lm.showPasswordIcon + lm.hidePasswordIcon
        });
        lm.passwordToggle = $('<button/>',{
            type: 'button',
            class: 'toggle-password ignore-drag',
            'aria-label': 'Show password',
            'aria-pressed': 'false',
            'aria-controls': 'session-signin-password',
            html: lm.passwordToggleIcon
        }).on('click', function(){
            const isPassword = lm.passwordInput.attr('type') === 'password';
            lm.passwordInput.attr('type', isPassword ? 'text' : 'password');
            lm.passwordToggle.toggleClass('is-password-visible', isPassword);
            lm.passwordToggle.attr('aria-label', isPassword ? 'Hide password' : 'Show password');
            lm.passwordToggle.attr('aria-pressed', isPassword ? 'true' : 'false');
        });
        lm.passwordErrors = $('<div/>',{
            class: 'field-error ignore-drag',
            id: 'session-signin-password-error',
            html: ''
        });
        lm.passwordInput = $('<input/>',{
            type: 'password',
            id: 'session-signin-password',
            name: 'password',
            maxlength: 128,
            required: true,
            autocomplete: 'current-password',
            placeholder: 'Password',
            class: 'ignore-drag password-input'
        });
        lm.passwordGroup = $('<div/>',{
            class: 'auth-input-group',
            html: [lm.lockIconEl, lm.passwordInput, lm.passwordToggle, lm.passwordErrors]
        });

        lm.formRow = $('<div/>',{
            class: 'auth-form-row',
            html: [lm.emailGroup, lm.passwordGroup]
        });

        lm.forgotLink = $('<a/>',{
            class: 'auth-forgot-link ignore-drag',
            href: `${isElectron ? api.global.app_url : ''}/password/reset`,
            target: '_blank',
            html: 'Forgot password?'
        });
        lm.actionsRow = $('<div/>',{
            class: 'auth-actions-row',
            html: lm.forgotLink
        });

        lm.signInButton = $('<button/>',{
            class: 'auth-submit-btn ignore-drag',
            type: 'submit',
            id: 'session-signin-btn',
            html: 'Sign In'
        });

        lm.signInForm = $('<form/>',{
            class: 'auth-form',
            id: 'session-signin-form',
            autocomplete: 'on',
            html: [lm.formRow, lm.actionsRow, lm.signInButton]
        }).on('submit', function(e){
            e.preventDefault();
            lm.signIn();
        });

        lm.terms = $('<div/>',{
            class: 'auth-terms',
            html: 'By signing in you agree to our <a href="/terms" target="_blank" class="ignore-drag">Terms</a> &amp; <a href="/privacy" target="_blank" class="ignore-drag">Privacy Policy</a>'
        });

        lm.formBody = $('<div/>',{
            class: 'auth-form-body',
            html: [lm.header, lm.socials, lm.divider, lm.generalErrorMessage, lm.signInForm, lm.terms]
        });

        lm.formPanel = $('<div/>',{
            class: 'auth-form-panel',
            html: [lm.banner, lm.formBody]
        });

        lm.modalContents = $('<div/>',{
            class: 'modal-content session-auth-modal-content',
            html: [lm.closeModalButton, lm.formPanel]
        });
        lm.modalDialog = $('<div/>',{
            class: 'modal-dialog modal-dialog-centered session-auth-modal-dialog',
            html: lm.modalContents
        });
        lm.modal = $('<div/>',{
            class: 'modal fade session-auth-modal',
            id: 'signInModalWelcome',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'signInModalWelcome',
            'aria-hidden': 'true',
            'data-backdrop': 'static',
            'data-keyboard': 'false',
            html: lm.modalDialog
        }).on('shown.bs.modal', function () {
            if (!String(lm.emailInput.val() || '').trim()) {
                lm.emailInput.focus();
            }
        });

        $('body').append(lm.modal);
        lm.modal.modal('show');
    }

    removeModal(){
        let lm = this;
        if(lm.modal){
            setTimeout(() => {
                lm.modal.remove();
                lm.modal = null;
            }, 200);
        }
    }

    async signIn(){
        let lm = this;
        let mail = String(lm.emailInput.val() || '').trim();
        let pw = lm.passwordInput.val();
        let rememberMe = isElectron;
        lm.disableJoinButton();

        lm.emailErrors.text('');
        lm.passwordErrors.text('');
        lm.generalErrorMessage.text('').hide();
        lm.emailInput.removeClass('input-error');
        lm.passwordInput.removeClass('input-error');

        if(!mail || !pw || !strTest.isValidEmail(mail)){
            clearTimeout(lm.timeout);
            lm.enableButton();
            if(!mail){
                lm.emailErrors.text('Required');
                lm.emailInput.addClass('input-error');
            }else if(!strTest.isValidEmail(mail)){
                lm.emailErrors.text('Invalid email');
                lm.emailInput.addClass('input-error');
            }
            if(!pw){
                lm.passwordErrors.text('Required');
                lm.passwordInput.addClass('input-error');
            }
        }else{
            if(isElectron){
                await axios.get(convertPath('/auth/signout') , await electronConfig()).then(res =>{
                }).catch(err => {
                    logError(err, 'logout'); notifyUser('Logout failed.');
                });
            }else{
                await axios.post('/logout',{}).then(res =>{
                }).catch(err => {
                    logError(err, 'logout'); notifyUser('Logout failed.');
                });
            }


            axios.post(convertPath(`${isElectron ? '/auth/signin' : '/login'}`), {
                email: mail,
                password: pw,
                remember_me: rememberMe
            }, await electronConfig()).then(async function(response){
                let data = response.data;
                console.log(data);
                if(data.error){
                    if(data.error == "Email verification is required"){
                        lm.emailErrors.html(`<div id="email-error-sign-in-as-host-inner">Email verification is required, <a href="${isElectron ? api.global.app_url: ''}/signIn" style="color:#d32f2f;">Click to verify from Homepage</a></div>`);
                        lm.emailInput.addClass('input-error');
                    }else{
                        lm.generalErrorMessage.text(data.error).show();
                    }
                    clearTimeout(lm.timeout);
                    lm.enableButton();
                }else{
                    if(isElectron){
                        await setUser(data);
                        await getData();
                    }
                    // Lobby sign-in needs a full reload so host/member access
                    // and permissions are recomputed. In-session sign-in must
                    // keep the live call connected.
                    if (!isJoined) {
                        window.location.reload();
                        return;
                    }
                    if (lm.modal) {
                        lm.modal.modal('hide');
                    }
                    lm.removeModal();
                    $('#sessionExpired-').remove();
                    clearTimeout(lm.timeout);
                    lm.enableButton();
                }
            }).catch(function(err){
                console.log(err.response);
                clearTimeout(lm.timeout);
                lm.enableButton();
                const data = err.response?.data;
                lm.generalErrorMessage.text(data?.error ?? "An error occurred, please try again").show();
            });
        }
    }

    disableJoinButton(){
        let lm = this;
        lm.signInButton.attr('disabled', 'disabled');
        lm.signInButton.html('Signing in…<span class="spinner"></span>');
        lm.timeout = setTimeout(() => {
            lm.enableButton();
        }, 10000);
    }
    enableButton(){
        let lm = this;
        lm.signInButton.removeAttr('disabled');
        lm.signInButton.html('Sign In');
    }
}
